<template>
    <div>
        <div class="row pxo-3 mbo-3">
            <div class="col-6 text-uppercase d-flex align-items-center">
                <span class="tooltip-selector">
                    Request Withdraw
                    <img
                        class="tooltip-icon"
                        src="/images/icon-info-green.svg"
                        alt="ingfo"
                    />
                    <div class="tooltip-container">
                        <div class="tooltip-bg-blur">
                            <ul>
                                <li class="mb-1">
                                    Make a withdrawal if you have pending
                                    withdrawals
                                </li>
                                <li class="mb-1">
                                    Withdrawals can only be executed after
                                    settlement of the current epoch
                                </li>
                            </ul>
                        </div>
                    </div>
                </span>
            </div>
        </div>
        <div style="display:flex;" class="mbo-3">
            <div
                class="input-group input-group-outline mbo-3___ flex-nowrap"
                style="/* margin-left:1em */"
            >
                <input
                    type="number"
                    class="form-control mto-1"
                    :placeholder="`0 ${vault.real_token_symbol.toUpperCase()}`"
                    aria-label="Withdrawl"
                    aria-describedby="basic-addon2"
                    v-model="withdrawlInput"
                    :disabled="canInitWithdraw || vault.userInfo.activeDeposit <= 0"
                    id="withdraw-input"
                    @keypress="isNumber($event)"
                />
                <div class="input-group-append text-center">
                    <a
                        id="max-withdraw"
                        :class="
                            canInitWithdraw || vault.userInfo.activeDeposit <= 0
                                ? 'disabled'
                                : ''
                        "
                        @click="getMaxWithdrawal"
                        class="text-green-gradient max-button-style"
                        href="#"
                        >MAX</a
                    >
                </div>
            </div>
            <div class="input-group-prepend ml-1">
                <button
                    v-if="!requesting"
                    class="btn p-0 btn-sm btn-primary text-center btn-withdraw-request"
                    type="button"
                    style="width: 100%;font-size: 80%;padding: 0px 12px !important;height: 88%;margin-top:3%;"
                    :disabled="
                        canInitWithdraw ||
                            withdrawlInput == '' ||
                            withdrawlInput <= 0
                    "
                    @click="initWithdraw"
                    id="init-withdraw"
                >
                    Request
                </button>
                <div v-else>
                    <div class="stageX">
                        <div class="dot-falling"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pxo-3 mbo-3">
            <div
                class="col-12 text-uppercase d-flex align-items-center"
                style="border-top: 1px solid rgba(255,255,255, 0.5); padding-top: 10px;"
            >
                <span class="tooltip-selector">
                    Withdraw
                    <img
                        class="tooltip-icon"
                        src="/images/icon-info-green.svg"
                        alt="ingfo"
                    />
                    <div class="tooltip-container">
                        <div class="tooltip-bg-blur">
                            <ul>
                                <li class="mb-1">
                                    Make a withdrawal if you have pending
                                    withdrawals
                                </li>
                                <li class="mb-1">
                                    Withdrawals can only be executed after
                                    settlement of the current epoch
                                </li>
                            </ul>
                        </div>
                    </div>
                </span>
            </div>
        </div>
        <div class="row pxo-3 mbo-3">
            <div class="col-6 text-uppercase">
                pending withdrawals
            </div>
            <div
                class="col-6 text-right font-weight-bold"
                style="text-transform:uppercase"
            >
                <span id="withdraw-pending"> {{ vault.pQueuedWithdraws }}</span>
                {{ vault.real_token_symbol.toUpperCase() }}
                <div v-if="!canWithdraw">
                    <div>OR</div>
                    <span id="withdraw-pending"> {{ calcLPWithdraw }}</span>
                    {{ vault.reverse_token_symbol.toUpperCase() }}
                </div>
            </div>
        </div>
        <div class="row pxo-3 mbo-3">
            <template v-if="canWithdraw">
                <div class="col-12 text-uppercase" style="text-align: center;">
                    Settled, ready for withdrawal
                </div>
            </template>
            <template v-else-if="isExpired">
                <div class="col-12 text-uppercase" style="text-align: center;">
                    withdrawal ready after settlement
                </div>
            </template>
            <template v-else>
                <div class="col-6 text-uppercase">
                    processing starts in
                </div>
                <div class="col-6 text-right font-weight-bold">
                    <count-down
                        v-if="vault"
                        :expiry="new Date(vault.expiry * 1000).toISOString()"
                        :vault="vault"
                        id="expiry-withdraw"
                    />
                </div>
            </template>
        </div>
        <div class="row">
            <template v-if="!withdrawing">
                <div class="col-6 d-flex">
                    <button
                        class="btn btn-secondary btn-vault-strip"
                        type="button"
                        @click="cancelWithdraw"
                        id="cancel-withdraw"
                        :disabled="canCancelWithdraw || canWithdraw"
                    >
                        cancel
                    </button>
                </div>
                <div class="col-6 d-flex justify-content-end">
                    <button
                        class="btn btn-primary btn-vault-strip"
                        type="button"
                        :disabled="!canWithdraw"
                        @click="doWithdraw"
                        id="do-withdraw"
                    >
                        withdraw
                    </button>
                </div>
            </template>
            <div v-else class="col-12 justify-center">
                <div
                    style="display: flex;align-items: center;margin-left: 2em; justify-content:center;"
                >
                    <div class="text-green-gradient">
                        {{ loadingText }}
                    </div>
                    <div>&nbsp;</div>
                    <div
                        style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                    >
                        <div class="dot-falling"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
    data() {
        return {
            withdrawlInput: null,
            loadingText: "Withdrawing"
        };
    },
    watch: {
        vault(v) {},
        withdrawlInput(v,o){
            const splitValue = v.split('.');
            const token = this.wallet.tokens.find(item => item.symbol == this.vault.real_token_symbol && item.network == this.vault.network);

            const decimalPlaces = (splitValue[1]).length; // count decimal places
            if(decimalPlaces > token.decimals.toString().length - 1) this.withdrawlInput = o // compare inputed amount decimal with token decimal
        }
    },
    computed: {
        ...mapState("il", [
            "vault",
            "tab",
            "contract",
            "checkingApproval",
            "requesting",
            "withdrawing",
            "ableToInitWithdraw",
            "hasQueuedWithdrawls"
        ]),
        ...mapState(["wallet"]),
        canCancelWithdraw() {
            return !(
                +this.vault.userInfo?.exitQueueEpoch > 0 &&
                +this.vault.userInfo?.queuedWithdraw > 0
            );
        },
        canWithdraw() {
            //
            if (this.vault.userInfo?.exitQueueEpoch == 0) return false;
            // console.log('canWithdraw',this.vault.epoch,+this.vault.userInfo?.exitQueueEpoch)
            if (
                (this.vault.epoch == +this.vault.userInfo?.exitQueueEpoch - 1 &&
                    this.vault.expiry == 0) ||
                (this.vault.epoch >= +this.vault.userInfo?.exitQueueEpoch &&
                    this.vault.expiry == 0)
            ) {
                return true;
            } else {
                return false;
            }
        },
        canInitWithdraw() {
            return !this.ableToInitWithdraw;
        },
        isExpired() {
            //
            if (this.vault.expiry == null) return false;
            return moment
                .utc(+(this.vault.expiry + "000"))
                .isBefore(moment.utc());
        },
        calcMaxWithdrawal() {
            const maxWithdrawal = this.vault.userInfo?.maxWithdrawIL !== undefined ? this.vault.userInfo?.maxWithdrawIL : 0;

            return maxWithdrawal;
        },
        calcLPWithdraw() {
            const strike_price = +this.vault.strike_price / 1e6;
            const exit_token = +this.vault.userInfo.queuedWithdraw;
            if (exit_token == 0) return 0;
            if (this.vault.type == "covered_call") return exit_token * strike_price;
            else return exit_token / strike_price;
        }
    },
    methods: {
        ...mapActions("il", ["setData"]),

        getMaxWithdrawal() {
            this.withdrawlInput = this.calcMaxWithdrawal;
        },
        async initWithdraw() {
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.vault.real_token_symbol &&
                    item.network == this.vault.network
            );
            if (token == undefined) return;

            this.setData({ key: "requesting", value: true });
            this.setData({ key: "checkingApproval", value: true });

            let payload = {
                vault_contract: this.vault.contract_address,
                amount: this.withdrawlInput,
                abiType: this.vault.type,
                maxWithdraw: this.calcMaxWithdrawal,
                token: token,
                queuedDeposits: this.vault.pQueuedDeposits,
                is_il: this.vault.is_il
            };

            try {
                withdrawRes = await this.$store.dispatch(
                    "vaults/initWithdraw",
                    payload
                );
            } catch (error) {
                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    withdrawRes = await this.$store.dispatch(
                        "vaults/initWithdraw",
                        payload
                    );
                }
            }

            // this.$emit("update-vault");

            this.withdrawlInput = null;
            this.setData({ key: "requesting", value: false });
            this.setData({ key: "checkingApproval", value: false });
        },
        async cancelWithdraw() {
            this.loadingText = "Cancelling";
            this.setData({ key: "withdrawing", value: true });
            let payload = {
                vault_contract: this.vault.contract_address,
                abiType: this.vault.type,
                is_il: true
            };

            try {
                await this.$store.dispatch("vaults/cancelWithdraw", payload);
            } catch (error) {
                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    await this.$store.dispatch(
                        "vaults/cancelWithdraw",
                        payload
                    );
                }
            }

            // this.$emit("update-vault");

            this.withdrawlInput = 0;
            this.setData({ key: "withdrawing", value: false });
        },
        async doWithdraw() {
            this.loadingText = "Withdrawing";
            this.setData({ key: "withdrawing", value: true });

            let payload = {
                vault_contract: this.vault.contract_address,
                abiType: this.vault.type,
                is_il: true
            };

            try {
                await this.$store.dispatch("vaults/doWithdraw", payload);
            } catch (error) {
                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    await this.$store.dispatch("vaults/doWithdraw", payload);
                }
            }

            this.setData({ key: "withdrawing", value: false });

            // this.$emit("update-vault");
        }
    }
};
</script>
